import { useState } from "react";
import { Label, TextArea } from "react-aria-components";
import { UseFormRegisterReturn } from "react-hook-form";

interface IFormTextAreaWrapper{
    value: string,
    label: string,
    onChange: Function,
    required: boolean,
    validateRule?: Function,
	validationError?: string,
    autocomplete?: string
    name?: string
    register?: UseFormRegisterReturn<string>
}

function getValidationError(
    value: string,
    required: boolean,
    validateRule?: Function,
    validationError?: string | null
): string | null {
    if (required && (value == null || String(value).trim() === "")) {
        return validationError ?? "Required";
    }
    if (validateRule && !validateRule(value)) {
        return validationError ?? "Invalid";
    }
    return null;
}

export default function FormTextAreaWrapper({value, label, required, onChange, validateRule, validationError, autocomplete, name, register}: IFormTextAreaWrapper) {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    if (register) {
        const handleBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
            register.onBlur(e);
            const val = e.target.value;
            setErrorMessage(getValidationError(val, required, validateRule, validationError));
        };

        return (
            <div>
                <label htmlFor={register.name} className="small margin__bottom--xxxs display--block">{label}{required ? " (required)" : ""}</label>
                <textarea
                    id={register.name}
                    aria-labelledby={label}
                    required={required}
                    className="form__text-area"
                    rows={10}
                    minLength={(required ? 1 : undefined)}
                    draggable={false}
                    autoComplete={autocomplete}
                    {...register}
                    onBlur={handleBlur}
                />
                {errorMessage && <div className="form__field-error" role="alert">{errorMessage}</div>}
            </div>
        );
    }

    function handleChange(e: React.ChangeEvent<HTMLTextAreaElement>){
        onChange(e.target.value);
    }

    function isDisabled() {
        return false
    }

    return (
        <div>
            <Label id={label} className="small margin__bottom--xxxs display--block">{label}{required ? " (required)" : ""}</Label>
            <TextArea 
                value={value}
                aria-labelledby={label}
                onChange={handleChange}
                required={required}
                className="text-area width--full"
                rows={10}
                minLength={(required ? 1 : undefined)}
                draggable={false}
                disabled={isDisabled()}
                autoComplete={autocomplete}
                name={name}/>
        </div>
    )
}